// extracted by mini-css-extract-plugin
export var actionText = "_lc-4";
export var container = "_lc-0";
export var leftSection = "_lc-1";
export var rightSection = "_lc-2";
export var settingsButton = "_lc-6";
export var settingsIcon = "_lc-7";
export var shortcut = "_lc-5";
export var shortcutGroup = "_lc-3";